// Figures out the event we are using with the bound element
// https://github.com/dhershman1/vue-debounce
// https://blog.csdn.net/sinat_36146776/article/details/84953131

import { debounce } from 'throttle-debounce';
import { on, off } from '@/utils/dom';

var fn = null;
export default {
  name: 'debounce',
  install: function install(Vue) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$defaultTime = _ref.defaultTime,
        defaultTime = _ref$defaultTime === undefined ? 300 : _ref$defaultTime;

    Vue.directive('debounce', {
      bind: function bind(el, _ref2) {
        var value = _ref2.value,
            arg = _ref2.arg,
            modifiers = _ref2.modifiers;

        fn = debounce(arg || defaultTime, value);
        on(el, 'click', fn);
      },


      unbind: function unbind(el) {
        if (fn) {
          off(el, 'click', fn);
        }
      }
    });
  }
};